type HandleSavedReplyErrorProps = {
  typename: string
  operation: string
  element: string
}

export const handleSavedReplyError = ({
  typename,
  operation,
  element,
}: HandleSavedReplyErrorProps): void => {
  switch (typename) {
    case 'LimitReachedError':
      throw new Error(
        `You have reached the limit of ${element}. Please upgrade your plan to add more ${element}`,
      )
    case 'NotFoundError':
      throw new Error(`${element} not found, maybe it was deleted`)
    case 'InvalidInputError':
      throw new Error(`Invalid input, please review the data and try again`)
    default:
      throw new Error(
        `Failed to ${operation} ${element}, please try again later or contact support`,
      )
  }
}
